import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { accountApi, Banner, TileGroup } from "../../api";

import Layout from "../../components/Layout/Layout";
import TitleMeta from "../../common/components/TitleMeta";
import Carousel from "../../components/Carousel/Carousel";
import TileGroupRow from "../../components/NavTile/TileGroupRow";

const Home = () => {

  const [banners, setBanners] = useState<Banner[]>();

  const [tileGroups, setTileGroups] = useState<TileGroup[] | []>([]);
  const [isLoadingTiles, setIsLoadingTiles] = useState(false);

  const showBanner = !!banners && banners.length !== 0;

  const fetchBannerData = async () => {
    try {
      const data = (await accountApi.getBanners()).data;
      setBanners(data);
    }
    catch {
      setBanners([]);
    }
  };

  useEffect(() => {
    setIsLoadingTiles(true);
    accountApi.getTiles()
      .then(response => {
        if (response?.data?.length) {
          setTileGroups(response?.data);
          setIsLoadingTiles(false);
        }
      })
      .catch((e) => {
        setIsLoadingTiles(false);
      });
  }, []);

  useEffect(() => {
    if (!banners) {
      fetchBannerData();
    }
  }, [banners]);

  return (

    <>
      <TitleMeta title="Welcome" />

      <Layout.FullPage>
        <div className="flex-grow-1 pt-4">

          <Layout.Body>

            {/* Banner */}
            {showBanner && (
              <Row>
                <Col>
                  <div className="box-shadow-2 rounded-xs-2 rounded-sm-2 rounded-md-3 rounded-lg-4 rounded-xl-5 overflow-hidden mb-5">
                    <Carousel items={banners}></Carousel>
                  </div>
                </Col>
              </Row>
            )}

            {/* Tiles */}
            {tileGroups.map((tileGroup, index) => (
              <TileGroupRow key={`${tileGroup.title}_${index}`}
                tileGroup={tileGroup} />
            ))}

          </Layout.Body>

        </div>
      </Layout.FullPage>
    </>
  );
};

export default Home;
